import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProfile, getRights } from "../redux/actions/auth.action";
import {
  logoutUser,
  updateProfile,
  updateRights,
} from "../redux/reducers/auth.reducer";
import { persistor } from "../redux/reducers/root";

function InitData() {
  const { token, profile } = useSelector((state: any) => state.auth);
  const dispatch = useDispatch();

  const initProFile = async () => {
    const resp = await getProfile({ token });
    if (resp.status === 200) {
      dispatch(updateProfile(resp.data));
    } else {
      dispatch(logoutUser());
      localStorage.clear();
      persistor.pause();
      persistor.flush().then(() => {
        window.location.reload();
        return persistor.purge();
      });
    }
  };
  const initRights = async () => {
    const rights = await getRights({ token, email: profile?.group_id });
    dispatch(updateRights(rights));
  };

  const getInitData = async () => {
    await initProFile();
  };

  useEffect(() => {
    if (token) {
      getInitData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    if (profile) {
      initRights();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile]);

  return null;
}

export default InitData;
